export default "__VITE_ASSET__a25dced5__"